import { render, staticRenderFns } from "./ExportCRM.vue?vue&type=template&id=b93a02fe&scoped=true&"
import script from "./ExportCRM.vue?vue&type=script&lang=js&"
export * from "./ExportCRM.vue?vue&type=script&lang=js&"
import style0 from "./ExportCRM.vue?vue&type=style&index=0&id=b93a02fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b93a02fe",
  null
  
)

export default component.exports